import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/atmolab_server_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addTeam from './component/addTeam.vue';
import addBindCoach from './component/addBindCoach.vue';
import coachList from './component/coachList.vue';
import parameterPopupone from '@/components/parameterPopupone/parameterPopupone.vue';
import { loadMoreList, commonData } from "@/mixins/index";
export default {
  name: "teamList",
  mixins: [loadMoreList, commonData],
  components: {
    addTeam: addTeam,
    parameterPopupone: parameterPopupone,
    addBindCoach: addBindCoach,
    coachList: coachList
  },
  data: function data() {
    return {
      paramsData: {
        page: 1,
        name: '',
        can_register: '',
        age_group: ''
      },
      tableData: [],
      total: 0,
      ageGroupList: [],
      registerList: [{
        label: '是',
        value: 1
      }, {
        label: '否',
        value: 0
      }]
    };
  },
  created: function created() {
    this.getList();
    this.getAgeGroupListFn();
  },
  methods: {
    getAgeGroupListFn: function getAgeGroupListFn() {
      var _this = this;

      this.$api.ageGroupList().then(function (res) {
        if (res.code == 200) {
          _this.ageGroupList = res.data;
        }
      });
    },
    getList: function getList() {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var page;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this2.paramsData.page = page;

                _this2.$api.getTeamsAllList(_this2.paramsData).then(function (res) {
                  if (res.code == 200) {
                    _this2.tableData = res.data.data;
                    _this2.total = res.data.total;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;

      this.$confirm("此操作将删除该球队, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.$api.delTeams({
                  id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this3.$message.success("删除成功!");

                    _this3.getList(_this3.paramsData.page);
                  } else {
                    _this3.$message.error(res.msg);
                  }
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }
  }
};